/**
 * Creates DOM-based map markers for city/district SRP maps using Mapbox or MapTiler SDK.
 */
export function useMapMarker() {
  const testingStore = useTestingStore();
  let mapMarkerSdkPromise = null;

  const resolveMapMarkerSdk = () => {
    if (false) {
      return Promise.resolve(null);
    }

    if (!mapMarkerSdkPromise) {
      const isMapTilerEnabled = testingStore.hasEnabledFeature('web_enableMapTiler');
      mapMarkerSdkPromise = isMapTilerEnabled
        ? import('@maptiler/sdk')
        : import('mapbox-gl');
    }

    return mapMarkerSdkPromise;
  };

  const preloadMapMarkerSdk = () => resolveMapMarkerSdk();

  const createDomMarker = async ({
    element,
    anchor = 'bottom',
    lngLat,
  }) => {
    if (false) {
      return null;
    }

    if (!element || !lngLat) {
      return null;
    }

    const sdkModule = await resolveMapMarkerSdk();
    if (!sdkModule) {
      return null;
    }

    const isMapTilerEnabled = testingStore.hasEnabledFeature('web_enableMapTiler');

    if (isMapTilerEnabled) {
      const { Marker } = sdkModule;
      return new Marker({
        element,
        anchor,
      }).setLngLat(lngLat);
    }

    const mapboxgl = sdkModule.default || sdkModule;
    return new mapboxgl.Marker({
      element,
      anchor,
    }).setLngLat(lngLat);
  };

  return {
    createDomMarker,
    preloadMapMarkerSdk,
  };
}
